import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { useAuth } from '../../contexts/AuthContext';
import styles from '../../styles/components/BottomNavigation.module.css';

interface NavItem {
  path: string;
  icon: string;
  activeIcon: string;
  label: string;
  badge?: number;
}

const BottomNavigation: React.FC = React.memo(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cart } = useCart();
  const { currentUser } = useAuth();

  const navItems: NavItem[] = [
    {
      path: '/',
      icon: '🏠',
      activeIcon: '🏠',
      label: 'Ana Sayfa',
    },
    {
      path: '/urunler',
      icon: '📦',
      activeIcon: '📦',
      label: 'Ürünler',
    },
    {
      path: '/sepet',
      icon: '🛒',
      activeIcon: '🛒',
      label: 'Sepet',
      badge: cart.totalItems || 0,
    },
    {
      path: currentUser ? '/hesabim' : '/giris',
      icon: '👤',
      activeIcon: '👤',
      label: currentUser ? 'Hesabım' : 'Giriş',
    },
  ];

  const isActive = (path: string): boolean => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const handleNavClick = (path: string) => {
    navigate(path);
  };

  return (
    <nav className={styles.bottomNav} role="navigation" aria-label="Ana navigasyon">
      {navItems.map((item) => {
        const active = isActive(item.path);
        return (
          <button
            key={item.path}
            className={`${styles.navItem} ${active ? styles.active : ''}`}
            onClick={() => handleNavClick(item.path)}
            aria-label={item.label}
            aria-current={active ? 'page' : undefined}
          >
            <span className={styles.iconWrapper}>
              <span className={styles.icon}>{active ? item.activeIcon : item.icon}</span>
              {item.badge !== undefined && item.badge > 0 && (
                <span className={styles.badge} aria-label={`${item.badge} ürün`}>
                  {item.badge > 99 ? '99+' : item.badge}
                </span>
              )}
            </span>
            <span className={styles.label}>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
});

export default BottomNavigation;
